module.exports = __webpack_public_path__ + "img/icons_17.66b06af2.png";